import styled from 'styled-components';
import WithDirection from "../../../../config/withDirection";

const StyleWrapper = styled.div`
    opacity: 0;
    transition: .3s;

    [role='tablist'] {
        display: flex;
        background-color: rgba(252, 252, 252, 1);
        box-shadow: 0px 2px 4px 0px rgba(230, 230, 230, 0.5);
    }

    [role='tab'] {
        flex-grow: 1;
        position:relative;
        margin: 0;
        padding: 0;
        line-height: 42px;
        font-family: 'Montserrat';
        font-size: 19px;
        color: rgba(147, 147, 147, 1);
        text-align: center;
        letter-spacing: 0.08em;

        :after {
            position: absolute;
            right: 0; bottom: 0; left: 0;
            display: inline-block;
            content: '';
            height: 0;
            background-color: rgba(71, 178, 170, 1);
            transition: .1s;
        }
    }
    
    [role='tab'][aria-selected='true'] {
        border: 1px solid rgba(235, 235, 235, 1);
        background-color: rgba(241, 241, 241, 1);
        color: rgba(64, 55, 57, 1);

        :after { height: 4px; transition: .3s; }
    }
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/Tabs/Wrapper.js